"use client";

export function AuthClientWrapper({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
